import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-20a45743"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "drawer-nav-container" }
const _hoisted_2 = { class: "drawer-nav" }
const _hoisted_3 = { class: "drawer-nav-item" }
const _hoisted_4 = { class: "el-image__error" }
const _hoisted_5 = {
  style: {"max-width":"100%"},
  class: "text-ellipsis font-assistant drawer-nav-label"
}
const _hoisted_6 = { style: {"position":"absolute","left":"0","right":"0","bottom":"0","display":"flex","justify-content":"center"} }
const _hoisted_7 = { style: {"width":"26px","height":"4px","border-radius":"2px","overflow":"hidden","background-color":"#e9edf3"} }

import {computed, PropType, ref} from "vue";
import {AppConfigComponent, AppConfigComponentNavGroupItem} from "@/model/AppConfig";
import {DocumentDelete} from "@element-plus/icons-vue";


const __default__ = {
  name: "AppConfigComponentDrawerNavComponent"
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  component: {
    type: Object as PropType<AppConfigComponent>,
    required: false
  }
},
  setup(__props) {

const props = __props





const scrollLeft = ref<number>(0)
const scrollRef = ref<any>(null)
const scroll = (value: any) => {
  let element = scrollRef.value.$el.querySelector(".el-scrollbar__wrap")
  let scrollWidth = element.scrollWidth
  let offset = value.scrollLeft / (scrollWidth - scrollRef.value.$el.clientWidth) * 13
  scrollLeft.value = offset
}

/**
 * 将items按照5个每组进行分割
 */
const navItemsArray = computed(() => {
  if (props.component && props.component.navGroup) {
    let items = props.component.navGroup.items || []
    let itemsArray: AppConfigComponentNavGroupItem[][] = []
    let groupNum = 2
    for (let i = 0; i < groupNum; i++) {
      itemsArray.push([])
    }

    for (let i = 0; i < items.length; i++) {
      let item = items[i]
      let index = Math.floor(i / 5) % groupNum;
      itemsArray[index].push(item)
    }
    return itemsArray.filter((e) => e.length > 0)
  }

  return []
})

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(navItemsArray) && _unref(navItemsArray).length > 0)
      ? (_openBlock(), _createBlock(_component_el_scrollbar, {
          key: 0,
          ref_key: "scrollRef",
          ref: scrollRef,
          style: {"position":"relative","padding-bottom":"10px"},
          onScroll: scroll
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(navItemsArray), (navItems, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  style: _normalizeStyle([{"display":"flex"}, {marginTop: index > 0 ? '10px' : '0px'}])
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navItems, (item) => {
                    return (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createVNode(_component_el_image, {
                        class: "drawer-nav-icon",
                        src: item.icon
                      }, {
                        error: _withCtx(() => [
                          _createElementVNode("div", _hoisted_4, [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(DocumentDelete))
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 2
                      }, 1032, ["src"]),
                      _createElementVNode("label", _hoisted_5, _toDisplayString(item.name), 1)
                    ]))
                  }), 256))
                ], 4))
              }), 256))
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", {
                  style: _normalizeStyle([{marginLeft: scrollLeft.value + 'px'}, {"height":"4px","width":"13px","border-radius":"2px","overflow":"hidden","background-color":"#ff7f46"}])
                }, null, 4)
              ])
            ])
          ]),
          _: 1
        }, 512))
      : _createCommentVNode("", true)
  ]))
}
}

})